export const courses = [
  {
    id: 1, abbr: "CHPE", cat: "education", badge: "New Batch",
    title: "Certificate in Health Professionals Education",
    level: "Postgraduate Certificate",
    desc: "Most technologically advanced, LMS-integrated blended course designed for busy healthcare professionals with leading national and international faculty.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Blended" }, { l: "Starts", v: "March 2026" }, { l: "Fee", v: "Rs. 70,000" }],
    modules: ["Principles & Theories of Learning", "Pedagogical Strategies & Instructional Design", "Principles of Assessment", "Technology Enhanced Learning", "Curriculum Development & Design", "Professionalism, Leadership & Educational Innovation"],
    price: "Rs. 70,000", priceNote: "Per participant",
    link: "https://www.corteach.com/calender/chpe/",
  },
  {
    id: 2, abbr: "CODE", cat: "education", badge: null,
    title: "Certificate in Online & Distance Education",
    level: "Postgraduate Certificate",
    desc: "Learn to teach online with a difference. Recommended for all faculty, administrative staff, and educationists to master online teaching.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Blended" }, { l: "Sessions", v: "Bi-monthly" }, { l: "Fee (Local)", v: "Rs. 50,000" }],
    modules: ["Significance of Online & Distance Education", "Self-Paced & Instructor-Led Course Development", "Multimedia Learning Content Creation", "Learning Management System Management"],
    price: "Rs. 50,000", priceNote: "$200 International",
    link: "https://www.corteach.com/calender/code/",
  },
  {
    id: 3, abbr: "AIE", cat: "ai", badge: null,
    title: "Artificial Intelligence in Education",
    level: "Postgraduate Award",
    desc: "Transformative course opening new horizons in medical education through cutting-edge AI insights with best faculty and unparalleled interaction.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Level", v: "Postgraduate" }, { l: "Award", v: "AI Healthcare" }],
    modules: ["Fundamentals of AI in Medical Education", "AI Tools for Teaching & Learning", "AI-Driven Assessment Strategies", "Ethical & Future Perspectives of AI"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/aie/",
  },
  {
    id: 4, abbr: "AIL", cat: "ai", badge: null,
    title: "Artificial Intelligence in Leadership",
    level: "Postgraduate Certificate",
    desc: "Equipping healthcare leaders with AI competencies to drive institutional transformation and innovation in clinical and administrative decision-making.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Partner", v: "BMU" }, { l: "Level", v: "Certificate" }],
    modules: ["AI Foundations for Leaders", "Strategic AI Implementation", "AI Ethics & Governance in Healthcare"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/ail/",
  },
  {
    id: 5, abbr: "AIR", cat: "ai", badge: null,
    title: "Artificial Intelligence in Research",
    level: "Postgraduate Award",
    desc: "Understand AI's role in designing and writing research papers — from generating ideas and analysing data to improving the academic writing process.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Award", v: "AI Healthcare" }, { l: "Partner", v: "BMU" }],
    modules: ["Basics of AI & Research Applications", "AI Tools for Data Analysis", "AI-Assisted Academic Writing"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/air/",
  },
  {
    id: 6, abbr: "DAI-HP", cat: "ai", badge: null,
    title: "Diploma in AI for Health Professionals",
    level: "Postgraduate Diploma",
    desc: "A comprehensive diploma-level programme equipping health professionals with in-depth AI knowledge across education, research, and clinical leadership.",
    meta: [{ l: "Level", v: "Diploma" }, { l: "Mode", v: "Online" }, { l: "Duration", v: "Extended" }, { l: "Partner", v: "BMU" }],
    modules: ["AI Foundations & Health Applications", "Clinical Decision Support Systems", "AI in Education & Research"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/dai-hp/",
  },
  {
    id: 7, abbr: "CAMH-C", cat: "clinical", badge: "5th Batch",
    title: "Child & Adolescent Mental Health Certificate",
    level: "Postgraduate Certificate",
    desc: "Designed to enhance knowledge of clinicians working with children and adolescents. Develops a workforce that can guide and facilitate child mental health at all levels.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Self-Paced + Zoom" }, { l: "Sessions", v: "12 x 2hr Zoom" }, { l: "Batch", v: "5th Batch" }],
    modules: ["Child Mental Health Fundamentals", "Assessment of Children & Adolescents", "Therapeutic Interventions", "Supervision & Facilitation Skills"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/camh-c/",
  },
  {
    id: 8, abbr: "CMEJ", cat: "research", badge: "Apr 2026",
    title: "Certificate in Medical Editing & Journalism",
    level: "Postgraduate Certificate",
    desc: "6-month online certificate with 6 credit hours covering medical editing, peer review, publication ethics, and journal management.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Credits", v: "6 Credit Hours" }, { l: "Fee (PKR)", v: "65,000" }, { l: "Fee (Intl)", v: "$450" }],
    modules: ["Medical Writing for Editors", "Journal Policies & Peer Review", "Publication Ethics", "Online Journal Systems & Indexation"],
    price: "PKR 65,000", priceNote: "$450 International",
    link: "https://www.corteach.com/calender/cmej/",
  },
  {
    id: 9, abbr: "CPPC", cat: "clinical", badge: null,
    title: "Certificate in Patient-Physician Communication",
    level: "Postgraduate Award",
    desc: "Builds the therapeutic doctor-patient relationship — the heart and art of medicine. Beneficial for new graduates and HCPs aiming for international practice.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Fee (Local)", v: "Rs. 20,000" }, { l: "Fee (Intl)", v: "$80" }],
    modules: ["Foundations of Therapeutic Communication", "Non-Verbal Communication & Empathy", "Managing Patient Complaints", "Communication for International Practice"],
    price: "Rs. 20,000", priceNote: "$80 International",
    link: "https://www.corteach.com/calender/cppc/",
  },
  {
    id: 10, abbr: "CCR", cat: "research", badge: null,
    title: "Certificate in Clinical Research",
    level: "Postgraduate Award",
    desc: "Comprehensive clinical research training covering research methodology, ethics, data analysis, and trial management for healthcare professionals.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Level", v: "Award" }, { l: "Partner", v: "BMU" }],
    modules: ["Research Methodology & Design", "Clinical Trial Management", "Research Ethics & Governance"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/ccr/",
  },
  {
    id: 11, abbr: "QRC", cat: "research", badge: null,
    title: "Qualitative Research Course",
    level: "Postgraduate Certificate",
    desc: "Develop expertise in qualitative research methods from study design and data collection to thematic analysis and academic writing.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Online" }, { l: "Level", v: "Certificate" }, { l: "Partner", v: "BMU" }],
    modules: ["Qualitative Research Paradigms", "Interview & Focus Group Methods", "Thematic & Content Analysis"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/qrc/",
  },
  {
    id: 12, abbr: "CIMS", cat: "clinical", badge: null,
    title: "Certificate in Minimally Invasive Surgery",
    level: "Postgraduate Certificate",
    desc: "A specialised programme covering modern minimally invasive surgical techniques, laparoscopic procedures, and advanced operative skills.",
    meta: [{ l: "Duration", v: "6 Months" }, { l: "Mode", v: "Blended" }, { l: "Level", v: "Certificate" }, { l: "Partner", v: "BMU" }],
    modules: ["Principles of Minimally Invasive Surgery", "Laparoscopic Techniques & Skills", "Surgical Research & Evidence"],
    price: "Contact Us", priceNote: "For fee details",
    link: "https://www.corteach.com/calender/cims/",
  },
];

export const calendar = [
  { month: "March 2026", name: "Certificate in Health Professionals Education (CHPE)", detail: "Blended · 6 Months · Rs. 70,000 · Limited Seats", link: "https://www.corteach.com/calender/chpe/" },
  { month: "April 2026", name: "Certificate in Medical Editing & Journalism (CMEJ)", detail: "Online · 6 Months · PKR 65,000 / $450 Intl", link: "https://www.corteach.com/calender/cmej/" },
  { month: "Ongoing", name: "Artificial Intelligence in Education (AIE)", detail: "Online · 6 Months · BMU Award", link: "https://www.corteach.com/calender/aie/" },
  { month: "Ongoing", name: "Child & Adolescent Mental Health Certificate — 5th Batch", detail: "Self-Paced + Zoom · 6 Months · 12 Sessions", link: "https://www.corteach.com/calender/camh-c/" },
  { month: "Ongoing", name: "Certificate in Online & Distance Education (CODE)", detail: "Blended · 6 Months · Rs. 50,000 / $200 Intl", link: "https://www.corteach.com/calender/code/" },
  { month: "Ongoing", name: "Certificate in Patient-Physician Communication (CPPC)", detail: "Online · 6 Months · Rs. 20,000 / $80 Intl", link: "https://www.corteach.com/calender/cppc/" },
  { month: "Ongoing", name: "Artificial Intelligence in Leadership (AIL)", detail: "Online · 6 Months · BMU Certificate", link: "https://www.corteach.com/calender/ail/" },
  { month: "Ongoing", name: "Diploma in AI for Health Professionals", detail: "Online · Extended Programme · BMU Diploma", link: "https://www.corteach.com/calender/dai-hp/" },
];

export const filters = [
  { key: "all", label: "All Programmes" },
  { key: "education", label: "Health Education" },
  { key: "ai", label: "AI & Technology" },
  { key: "clinical", label: "Clinical Sciences" },
  { key: "research", label: "Research" },
];

export const announcements = [
  { title: "CHPE New Batch — March 2026", desc: "Certificate in Health Professionals Education new session opens March 2026. Limited seats available. LMS-integrated blended course with national and international faculty.", tag: "Enrollment Open" },
  { title: "AI in Healthcare Programme Series", desc: "BMU offers multiple AI-focused postgraduate programmes: AI in Research, AI in Education, AI in Leadership, and Diploma in AI for Health Professionals.", tag: "Multiple Programmes" },
  { title: "CMEJ — Starting April 2026", desc: "Certificate in Medical Editing and Journalism commences April 2026. Fee: PKR 65,000 (local) and $450 (international). Fully online delivery.", tag: "April 2026" },
  { title: "Child & Adolescent Mental Health — 5th Batch", desc: "The CAMH Certificate is now in its 5th batch. Targeted at General Practitioners, Psychiatrists, Pediatricians, Psychologists, and education professionals.", tag: "5th Batch" },
];

export const whyItems = [
  { title: "Accredited University", desc: "All certificates and diplomas are awarded by Baqai Medical University, established in 1996 as Pakistan's first community-based private medical university." },
  { title: "International Faculty", desc: "Leading national and international faculty from top-tier institutions worldwide, selected for expertise and excellence in medical education." },
  { title: "Flexible Delivery", desc: "Accessible on any device with online and blended delivery formats — designed specifically for busy healthcare and education professionals." },
  { title: "LMS-Integrated", desc: "State-of-the-art Learning Management System with video lectures, live sessions, assignments, discussion boards, and digital portfolios." },
  { title: "Affordable Programmes", desc: "World-class university credentials at an accessible price point, with early-payment discounts and flexible payment arrangements available." },
  { title: "Pastoral Support", desc: "Dedicated programme management team providing mentorship and pastoral care to ensure high completion rates and academic success." },
];
